module.exports = __webpack_public_path__ + "static/img/ip5@2x.ae52e6be.png";